import React, { FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { EvLinkNavigationTabs } from '@evinced-private/ui-common';

import {
	createDashboardTabOptions,
	getActiveTabFromPath
} from '../../helpers/TabNavigationHelpers';
import { DashboardTabId } from '../../types/DashboardTypes';
import { BusinessUnitSelector } from '../business-unit-selector/BusinessUnitSelector';

import './DashboardTabsNav.scss';

export const DashboardTabsNav: FC = () => {
	const history = useHistory();
	const { pathname } = useLocation();

	const activeTabId = getActiveTabFromPath(pathname);
	const options = createDashboardTabOptions(history);

	// Show business unit selector only when on business units page
	const showBusinessUnitSelector = activeTabId === DashboardTabId.BUSINESS_UNITS;

	return (
		<div className="dashboard-tabs-nav">
			<EvLinkNavigationTabs selectedTabId={activeTabId} options={options} />
			{showBusinessUnitSelector && <BusinessUnitSelector />}
		</div>
	);
};
